import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  html, body, #root {
    height: 100%;
  }
  html {
    background: #fff;
    background-image: url("data:image/svg+xml;utf8,\
      <svg xmlns='http://www.w3.org/2000/svg' width='48' height='56' viewBox='0 0 48 56' fill='none'>\
        <g stroke='rgba(0,0,0,0.06)' stroke-width='1'>\
          <path d='M12 2 L36 2 L48 22 L36 42 L12 42 L0 22 Z'/>\
          <path d='M12 42 L36 42 L48 62 L36 82 L12 82 L0 62 Z' transform='translate(0,-20)'/>\
          <path d='M-12 22 L12 22 L24 42 L12 62 L-12 62 L-24 42 Z'/>\
        </g>\
      </svg>");
    background-size: 48px 56px;
    background-repeat: repeat;
  }
  body {
    margin: 0;
    background: transparent; /* important! */
  }
`;
